export default "__VITE_ASSET__CEGKyhGf__"